import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'help/:topic',
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/HelpSectionPageContainer'),
  }),
};
